module.exports = __webpack_public_path__ + "static/img/b4.3e25816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b4.png
// module id = v8NB
// module chunks = 1